import moment from 'moment'

const calculateFields = (training_requirement, callback=null) => {
  const { frequency, date_completed, due_date, customized_due_date } = training_requirement;
  let status = 'needed'
  let date_completed_moment, due_date_moment, is_over_due, is_due_in_three_months, three_months_before_due_date;

  if (!date_completed){
    status = 'needed'
    due_date_moment = ''
    date_completed_moment = ''
  } else if (['x', 'X'].includes(date_completed)){
    status = 'not-needed'
    due_date_moment = ''
    date_completed_moment = ''
  } else if (frequency === null || frequency < 1) {
    status = 'completed'
    date_completed_moment = moment(date_completed).endOf('day')
  } else {
    date_completed_moment = moment(date_completed).endOf('day')
    due_date_moment = date_completed_moment.clone().add(frequency, 'years')
    if (customized_due_date) {
      due_date_moment = due_date ? moment(due_date).endOf('day') : due_date_moment
    }

    three_months_before_due_date = due_date_moment.clone().subtract(3, 'months')
    is_due_in_three_months = moment().isSame(three_months_before_due_date, 'day') || 
                      (moment().endOf('day').isAfter(three_months_before_due_date) && moment().endOf('day').isBefore(due_date_moment.clone()));
    is_over_due = moment().endOf('day').isAfter(due_date_moment) || moment().isSame(due_date_moment, 'day')
    if (is_due_in_three_months) {
      status = 'due-in-3-months'
    } else if (is_over_due) {
      status = 'overdue'
    } else {
      status = 'completed'
    }

  }

  training_requirement.date_completed = date_completed_moment
  training_requirement.status = status
  training_requirement.due_date = due_date_moment

  if (callback) callback(training_requirement)
  
  return training_requirement
}

export {
  calculateFields
}


// WEBPACK FOOTER //
// ./src/helpers/training_requirement_helpers.js